<template>
  <div>
    <!--标题-->
    <div class="detailsTitle">
      <h4>货主规则</h4>
    </div>
     <el-tabs  v-model="editableTabsValue" type="card"  style="margin-left:10px;"  @tab-click="handleClick">
    <el-tab-pane :key="index"
      v-for="(item, index) in editableTabs"
      :label="item.feeName"
      :name="item.id + ''">
      <!--查询条件-->
    <div class="searchBox" ref="searchBox">
      <el-form :inline="true" :model="searchFrom1" ref="searchFrom1" class="demo-form-inline" label-width="100px" size="mini">
        <div class=" inpBox">
          <el-form-item label="合同编号:" prop="defaultCno">
            <el-input  placeholder="" maxlength="100" v-model="searchFrom1.defaultCno"></el-input>
          </el-form-item>
          <el-form-item label="生效日期:" prop="sendcatTimeShow">
            <el-date-picker
              v-model="sendcatTimeShow"
              type="daterange"
              format="yyyy-MM-dd"
              value-format="yyyy-MM-dd"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期">
            </el-date-picker>
          </el-form-item>
          <el-form-item label="客户名称:" prop="defaultCname">
            <el-input  placeholder="" maxlength="100" v-model="searchFrom1.defaultCname"></el-input>
          </el-form-item>
        </div>
       <div class="searchBtnBox">
        <el-form-item>
          <el-button type="primary" @click="searchClick" btnCode='000P00ZB001' v-if="btnFlg[0]">查询</el-button>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="resetClick" btnCode='000P00ZB002' v-if="btnFlg[1]">重置</el-button>
        </el-form-item>
        <el-form-item>
          <el-button type="primary"  @click="addBtnClick" btnCode='000P00ZB003' v-if="btnFlg[2]">新增</el-button>
        </el-form-item>
        <el-form-item>
          <el-button type="primary"  @click="changeBtnClick" btnCode='000P00ZB004' v-if="btnFlg[3]">修改</el-button>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="delBtnClick" btnCode='000P00ZB005' v-if="btnFlg[4]">删除</el-button>
        </el-form-item>
       </div>
      </el-form>
    </div>
    <!--  表格 -->
    <div class="table" :style="{height:h}">
      <el-table
        :data="tableDate"
        ref="tableRef"
        border
        bordersize="mini"
        height="100%"
        style="width: 100%;margin-top:10px;"
        center
        @row-click="dianjixuanzhong"
        @current-change="handleTabCurrentChange"
        :header-cell-style="{background:'#F5F5F5',color:'black'}"
        :header-row-style="{height:'45px'}"
        :row-style="{height:'35px'}"
        highlight-current-row>
        <el-table-column v-for="(item,index) in tableHeardArr" :key="index"
        :prop="item.attrStandard"
        :label="item.attrName">
          <!-- if（interControl=2||interControl=4 ）显示用attrStandard 截取掉（-value） -->
        </el-table-column>
      </el-table>
    </div>
    <!-- 分页 10,25,50,100-->
    <div>
      <el-pagination background
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="searchFrom1.pageNo"
        :page-sizes="[10,25,50,100]"
        :page-size="searchFrom1.pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total">
      </el-pagination>
    </div>
    </el-tab-pane>
     <!--新增-->
    <el-dialog :title="title"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    :visible.sync="addDialog"
    width="900px"
    center>
      <span>
         <el-form
          :model="addFrom"
          ref="addFrom"
          :rules="rules"
          :validate-on-rule-change = "false"
          class="demo-form-inline"
          label-width="340px" size="mini">
        <div class="addinpBox"  v-for="(item,index) in addFrom.addDataList" :key="index">
          <!-- 文本框 有校验-->
          <el-form-item  :label="item.attrName"  v-if="item.interControl == '1' && item.isnotFlg == '0'"
            :prop="'addDataList.' + index + '.ext3'" :key="index"
            :rules="[
                { required: true, message: '此项不能为空', trigger: 'blur' },
              ]"
            style="margin-top:20px;">
            <el-input v-model="item.ext3" style="width:210px;" :validate-event = "false"></el-input>
          </el-form-item>
          <!-- 文本框 无校验-->
          <el-form-item  :label="item.attrName"  v-if="item.interControl == '1' && item.isnotFlg == '1'" style="margin-top:20px;">
            <el-input v-model="item.ext3" style="width:210px;" :validate-event = "false"></el-input>
          </el-form-item>
          <!-- 下拉框 有校验-->
          <el-form-item  :id="item.id" :label="item.attrName"  v-if="item.interControl == '2'  && item.isnotFlg == '0'"
            :prop="'addDataList.' + index + '.ext3'" :key="index"
            :rules="[
                { required: true, message: '此项不能为空', trigger: 'change' },
              ]"
            style="margin-top:20px;">
            <el-select v-model="item.ext3"  @change="selectChange(item.id)" :validate-event = "false" placeholder="请选择" style="width:210px;">
                <span  v-for="(i,index) in item.codeOptions" :key="index">
                  <el-option
                    :label="i.showName"
                    :value="i.itemNo">
                  </el-option>
                </span>
                </el-select>
          </el-form-item>
          <!-- 下拉框 无校验-->
          <el-form-item  :label="item.attrName"  v-if="item.interControl == '2'  && item.isnotFlg == '1'" style="margin-top:20px;">
            <el-select v-model="item.ext3" @change="selectChange2(item.id)" :validate-event = "false" placeholder="请选择" style="width:210px;">
                <span  v-for="(i,index) in item.codeOptions2" :key="index">
                  <el-option
                    :label="i.showName"
                    :value="i.itemNo">
                  </el-option>
                </span>
                </el-select>
          </el-form-item>
          <!-- 日期 有校验-->
          <el-form-item  :label="item.attrName"  v-if="item.interControl == '3'  && item.isnotFlg == '0'"
            :prop="'addDataList.' + index + '.ext3'" :key="index"
            :rules="[
                { required: true, message: '此项不能为空', trigger: 'blur' },
              ]"
            style="margin-top:20px;">
            <el-date-picker
                  placeholder="选择日期"
                  style="width:210px;"
                  v-model="item.ext3"
                  type="date"
                  :validate-event = "false"
                  format="yyyy-MM-dd"
                  value-format="yyyy-MM-dd"
                  >
                </el-date-picker>
          </el-form-item>
          <!-- 日期 无校验-->
          <el-form-item  :label="item.attrName"  v-if="item.interControl == '3'  && item.isnotFlg == '1'" style="margin-top:20px;">
            <el-date-picker
                  placeholder="选择日期"
                  style="width:210px;"
                  v-model="item.ext3"
                  type="date"
                  :validate-event = "false"
                  format="yyyy-MM-dd"
                  value-format="yyyy-MM-dd"
                  >
                </el-date-picker>
          </el-form-item>
          <!-- 复选框 有校验  :rules="[
                { required: true, message: '此项不能为空', trigger: 'change' },
              ]"-->
          <el-form-item  :label="item.attrName"  v-if="item.interControl == '4'  && item.isnotFlg == '0'"
            prop="checkDataArr"
            style="margin-top:20px;">
            <el-checkbox-group   v-model="checkDataArr">
              <el-checkbox
                    :validate-event = "false"
                    v-for="i in checkData"
                    :key="i.itemNo"
                    :label="i.showName"
                    :value="i.itemNo"
                    :checked="checkedFlg"
                    @change="checkChange(i,$event)"
                ></el-checkbox>
                </el-checkbox-group>
          </el-form-item>
          <!-- 复选框 无校验-->
          <el-form-item  :label="item.attrName"  v-if="item.interControl == '4'  && item.isnotFlg == '1'"  style="margin-top:20px;">
             <el-checkbox-group  v-model="checkDataArr">
              <el-checkbox
                    :validate-event = "false"
                    v-for="(i,index) in checkData"
                    :key="index"
                    :label="i.itemNo"
                    :checked="checkedFlg"
                    @change="checkChange(i,$event)"
                >{{i.showName}}</el-checkbox>
                </el-checkbox-group>
          </el-form-item>
        </div>
        <!-- 客户 -->
        <el-form-item  label="所属客户" prop='suoShuKeHu'  style="margin-top:20px;">
            <el-select v-model="addFrom.suoShuKeHu" @change="keHuChange" :validate-event = "false" placeholder="请选择" style="width:210px;">
                  <el-option
                    v-for="(item,index) in keHuOptions"
                    :key="index"
                    :label="item.showName"
                    :value="item.itemNo">
                  </el-option>
                </el-select>
          </el-form-item>
        <el-form-item  label="合同编号" style="margin-top:20px;">
          <el-input v-model="addFrom.contractNo" style="width:210px;" :validate-event = "false"></el-input>
        </el-form-item>
          <el-form-item  label="生效日期"
            prop='effectiveDate'
            style="margin-top:20px;">
            <el-date-picker
                  placeholder="选择日期"
                  style="width:210px;"
                  v-model="addFrom.effectiveDate"
                  type="date"
                  :validate-event = "false"
                  format="yyyy-MM-dd"
                  value-format="yyyy-MM-dd"
                  >
                </el-date-picker>
          </el-form-item>
          <el-form-item  label="有效日期"
            prop='validDate'
            style="margin-top:20px;">
            <el-date-picker
                  placeholder="选择日期"
                  style="width:210px;"
                  v-model="addFrom.validDate"
                  :validate-event = "false"
                  type="date"
                  format="yyyy-MM-dd"
                  value-format="yyyy-MM-dd"
                  >
                </el-date-picker>
          </el-form-item>
          <el-form-item label="适用标识:" prop="biaoShi" style="margin-top:20px;">
            <el-radio v-model="addFrom.biaoShi" label="0">特殊</el-radio>
            <el-radio v-model="addFrom.biaoShi" label="1">基础</el-radio>
          </el-form-item>
        </el-form>
      </span>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" size='mini'   @click="addSubmit('addFrom')" :loading='addLoading' v-if="addBtnShow">保存</el-button>
        <el-button type="primary" size='mini'   @click="changeSubmit('addFrom')" :loading='changeLoading' v-if="changeBtnShow">修改</el-button>
        <el-button @click="addSpuClose('addFrom')" size='mini'>取 消</el-button>
      </span>
    </el-dialog>
  </el-tabs>
  </div>
</template>
<script>
import {
  getSheetListBySysModel, // tab数据
  getCostDataList, // 列表查询
  getCostPageData, // 计费规则页面新增、编辑页面变量字段接口
  saveCostDataAdd, // 新增/修改
  seeGroupType, // 字典表
  deleteCostData, // 删除
  getQueryCusterData // 客户
} from '@/api/platform-settlement'
import DonMessage from '@/utils/message'
// eslint-disable-next-line no-unused-vars
import { getBtn } from '@/utils/getButton'
// eslint-disable-next-line no-unused-vars
import store from '@/store'
export default {
  data () {
    return {
      // 按钮
      btnFlg: [],
      btnIdArr: ['000P00ZB001', '000P00ZB002', '000P00ZB003',
        '000P00ZB004', '000P00ZB005'],
      activeName: 'first',
      editableTabs: [],
      tableDate: [],
      tableHeardArr: [],
      editableTabsValue: '',
      tabIndex: 2,
      title: '',
      h: '500px',
      total: 0,
      sendcatTimeShow: [],
      startTime: '',
      endTime: '',
      searchFrom1: {
        defaultCno: '',
        defaultCname: '',
        pageNo: 1,
        pageSize: 10
      },
      feeId: '',
      tabId: '',
      // 新增
      addLoading: false,
      changeLoading: false,
      addDialog: false,
      zhuangCheMingXiMark: false,
      addFrom: {
        customerName: '', // 客户名称
        goodsType: '', // 货物类型
        contractNo: '', // 合同编号
        effectiveDate: '', // 生效日期
        validDate: '', // 有效日期
        addDataList: [], // 新增修改动态表单
        modularIds: [],
        modularNames: [],
        suoShuKeHu: '', // 所属客户
        suoShuKeHuName: '', // name值
        biaoShi: '0'
      },

      codeOptions: [], // 下拉框数据
      codeOptions2: [],
      checkData: [], // 复选框数据
      changeBtnShow: false,
      addBtnShow: false,
      rules: {
        customerName: [
          { required: true, message: '客户名称不能为空', trigger: 'change' }
        ],
        goodsType: [
          { required: true, message: '获取类型不能为空', trigger: 'change' }
        ],
        suoShuKeHu: [
          { required: true, message: '所属客户不能为空', trigger: 'blur' }
        ],
        effectiveDate: [
          { required: true, message: '生效日期不能为空', trigger: 'blur' }
        ],
        validDate: [
          { required: true, message: '有效日期不能为空', trigger: 'blur' }
        ],
        biaoShi: [
          { required: true, message: '请选择适用标识', trigger: 'change' }
        ]
      },
      currentRow: '',
      xuanzhongArr: [],
      currentXQ: '',
      iptShow: false,
      seleName: '', // 下拉框name值
      seleName2: '',
      changeId: '',
      checkName: '', // 多选框name值
      // 复选框数组
      checkDataArr: [],
      checkarr: [],
      checkedFlg: false,
      keHuOptions: [] // 所属客户下拉框
    }
  },
  mounted () {
    // let h = this.$refs.searchBox.offsetHeight
    // let pH = document.documentElement.clientHeight
    // this.h = (pH - h - 150) + 'px'
  },
  created () {
    this.getSheetListBySysModel()
    // this.getListData()
    this.btnFlg = getBtn(this.btnIdArr, '/smpCost/cargoOwnerRules')
  },
  methods: {
    // 获取tab页数据
    getSheetListBySysModel () {
      getSheetListBySysModel({
        sysModel: '5'
      }).then(res => {
        this.editableTabs = res
        this.editableTabsValue = (this.editableTabs[0].id).toString()
        this.tabId = this.editableTabs[0].id
        this.getListData()
      }).catch(err => {
        DonMessage.error(err.message)
      })
    },
    // 点击tab
    handleClick (tab, event) {
      this.feeId = tab.name
      this.tableDate = []
      this.tableHeardArr = []
      this.sendcatTimeShow = []
      this.searchFrom1 = {
        defaultCno: '',
        defaultCname: '',
        pageNo: 1,
        pageSize: 10
      }
      this.getListData()
      // console.log(event,'22222')
    },
    // 获取列表数据
    getListData () {
      // console.log(this.tabId,'222')
      if (this.sendcatTimeShow != null) {
        this.startTime = this.sendcatTimeShow[0]
        this.endTime = this.sendcatTimeShow[1]
      } else {
        this.startTime = ''
        this.endTime = ''
      }
      getCostDataList({
        sysModel: '5',
        feeId: this.feeId || this.tabId,
        pageNo: this.searchFrom1.pageNo,
        pageSize: this.searchFrom1.pageSize,
        defaultCno: this.searchFrom1.defaultCno,
        defaultCname: this.searchFrom1.defaultCname,
        startTime: this.startTime,
        endTime: this.endTime
      }).then(res => {
        this.tableDate = res.dataList.list
        this.tableHeardArr = res.titleList
        this.total = res.dataList.total
      }).catch(err => {
        DonMessage.error(err.message)
      })
    },

    // 每页条数
    handleSizeChange (val) {
      this.searchFrom1.pageSize = val
      this.getListData()
    },
    // 当前页
    handleCurrentChange (val) {
      this.searchFrom1.pageNo = val
      this.getListData()
    },
    // 查询
    searchClick () {
      this.getListData()
    },
    // 重置
    resetClick () {
      this.sendcatTimeShow = []
      this.searchFrom1 = {
        defaultCno: '',
        defaultCname: '',
        pageNo: 1,
        pageSize: 10
      }
      this.getListData()
    },
    // 新增、编辑页面变量字段接口
    getCostPageData (val) {
      getCostPageData({
        sysModel: '5',
        feeId: this.feeId || this.tabId
      }).then(res => {
        this.addFrom.addDataList = res
        for (let value in this.addFrom.addDataList) {
          this.$set(this.addFrom, value, [])
        }
        this.addFrom.addDataList.forEach((item, index) => {
          if (item.interControl == '2' || item.interControl == '4') {
            if (item.dsourceFlg == '1') {
              if (item.isnotFlg == '0') {
                this.$axios({
                  url: item.dataSource,
                  method: 'post',
                  data: {},
                  headers: {
                    'Content-Type': 'application/json;charset=UTF-8',
                    Authorization: 'Bearer ' + store.getUser().access_token
                  }
                }).then(response => {
                  var res = response.data
                  if (item.interControl == '2') {
                    this.addFrom.addDataList[index].codeOptions = res
                    this.$forceUpdate()
                    // console.log(this.addFrom.addDataList[index].codeOptions, '/////')
                  }
                  if (item.interControl == '4') {
                    this.checkData = res
                  }
                })
                  .catch(error => {
                    DonMessage.error(error.message)
                  })
              } else {
                this.$axios({
                  url: item.dataSource,
                  method: 'post',
                  data: {},
                  headers: {
                    'Content-Type': 'application/json;charset=UTF-8',
                    Authorization: 'Bearer ' + store.getUser().access_token
                  }
                }).then(response => {
                  var res = response.data
                  if (item.interControl == '2') {
                    this.addFrom.addDataList[index].codeOptions2 = res
                    this.$forceUpdate()
                    // console.log(this.addFrom.addDataList[index].codeOptions2, '.......')
                  }
                  if (item.interControl == '4') {
                    this.checkData = res
                  }
                })
                  .catch(error => {
                    DonMessage.error(error.message)
                  })
              }
            } else {
              // 有校验下拉框数据
              if (item.isnotFlg == '0') {
                // 获取新增下拉框复选框数据
                seeGroupType({
                  groupNo: item.dataSource // 获取编码
                }).then(res => {
                  if (item.interControl == '2') {
                    // this.codeOptions = res
                    // this.$nextTick(() => {
                    this.addFrom.addDataList[index].codeOptions = res
                    this.$forceUpdate()
                    // console.log(this.addFrom.addDataList[index].codeOptions, '000000000000')
                    // })
                  }
                  if (item.interControl == '4') {
                    this.checkData = res
                  }
                }).catch(err => {
                  DonMessage.error(err.message)
                })
              } else if (item.isnotFlg == '1') {
                // 获取新增下拉框复选框数据
                seeGroupType({
                  groupNo: item.dataSource // 获取编码
                }).then(res => {
                  if (item.interControl == '2') {
                    // this.codeOptions2 = res
                    this.addFrom.addDataList[index].codeOptions2 = res
                    this.$forceUpdate() // 强制刷新
                    // console.log(this.addFrom.addDataList[index].codeOptions2, '11111111111')
                  }
                  if (item.interControl == '4') {
                    this.checkData = res
                  }
                }).catch(err => {
                  DonMessage.error(err.message)
                })
              }
            }
          }
        })
        let str = ''
        if (val != null || val != undefined || val != '') {
          // console.log('00000')
          this.addFrom.addDataList.forEach((item, index) => {
            if (item.ext3 == undefined) {
              item.ext3 = ''
            }
            if (item.interControl == '4') {
              this.checkDataArr = (val[item.attrStandard.substring(0, item.attrStandard.length - 6)] || '').split(',')
              this.addFrom.modularIds = (val[item.attrStandard] || '').split(',')
            } else {
              str = item.attrStandard
              item.ext3 = val[str]
            }
          })
        }
      }).catch(err => {
        DonMessage.error(err.message)
      })
    },
    // 获取所属客户数据
    getQueryCusterData () {
      getQueryCusterData().then(res => {
        this.keHuOptions = res
      }).catch(err => {
        DonMessage.error(err.message)
      })
    },
    keHuChange (val) {
      // 同时获取车队下拉框的valu和lable值
      this.keHuOptions.forEach((item, index) => {
        if (item.itemNo == val) {
          this.addFrom.suoShuKeHu = item.itemNo
          this.addFrom.suoShuKeHuName = item.showName
        }
      })
      // console.log(val, '1111')
      // console.log(this.addFrom.suoShuKeHu, '2222')
      // console.log(this.addFrom.suoShuKeHuName, '3333')
    },
    // 点击新增按钮
    addBtnClick () {
      this.addDialog = true
      this.title = '添加计费规则'
      this.addBtnShow = true
      this.changeBtnShow = false
      this.addFrom = {
        customerName: '', // 客户名称
        goodsType: '', // 货物类型
        contractNo: '', // 合同编号
        effectiveDate: '', // 生效日期
        validDate: '', // 有效日期
        addDataList: [] // 新增修改动态表单
      }
      this.getCostPageData('')
      this.getQueryCusterData()
    },
    // 下拉框值改变时
    selectChange (id) {
      // console.log(id, '////')
      // 下拉框name值问题
      this.addFrom.addDataList.forEach((item, index) => {
        if (item.interControl == '2' && item.id == id) {
          this.addFrom.addDataList[index].codeOptions.forEach((a) => {
            if (item.ext3 == a.itemNo) {
              this.seleName = a.showName
              // console.log(this.seleName, '333')
            }
          })
          item.ext2 = this.seleName
          // console.log(item.ext2, '2222')
        }
      })
    },
    // 不校验
    selectChange2 (id) {
      this.addFrom.addDataList.forEach((item, index) => {
        if (item.interControl == '2' && item.id == id) {
          this.addFrom.addDataList[index].codeOptions2.forEach((a) => {
            if (item.ext3 == a.itemNo) {
              this.seleName2 = a.showName
              // console.log(this.seleName, '333')
            }
          })
          item.ext2 = this.seleName2
          // console.log(item.ext2, '2222')
        }
      })
    },
    // 去除数组的空字符串
    trimSpace (array) {
      for (var i = 0; i < array.length; i++) {
        if (array[i] == '' || array[i] == null || typeof (array[i]) == 'undefined') {
          array.splice(i, 1)
          i = i - 1
        }
      }
      return array
    },
    // 复选框的值改变时
    checkChange (i, e) {
      // console.log(e, '0000')
      // 同时获取复选框的value和label值
      this.addFrom.modularIds = []
      // if (this.checkarr.indexOf(i.itemNo) == -1) {
      //   this.checkarr.push(i.itemNo)
      // } else {
      //   this.checkarr.splice(this.checkarr.indexOf(i.itemNo), 1)
      // }
      // this.addFrom.modularIds = this.checkarr
      this.addFrom.modularNames = this.checkDataArr

      // this.trimSpace(this.addFrom.modularIds)
      this.trimSpace(this.addFrom.modularNames)
      // console.log('this.name.--', this.trimSpace(this.checkDataArr))
      // console.log('this.id.--', this.trimSpace(this.addFrom.modularIds))
      this.addFrom.addDataList.forEach((item, index) => {
        if (item.interControl == '4') {
          item.ext2 = this.checkDataArr.toString()
          this.addFrom.modularIds = []
          this.checkData.forEach((a, index) => {
            if (this.checkDataArr.indexOf(a.showName) != -1) {
              this.addFrom.modularIds.push(a.itemNo)
            } else {
              this.addFrom.modularIds.splice(a.itemNo, 1)
            }
          })
          // console.log(Array.from(new Set(this.addFrom.modularIds)), '99999')
        }
      })
    },
    // 新增保存
    addSubmit (formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.addLoading = true
          let feeId = this.feeId
          let keHuCode1 = this.addFrom.suoShuKeHu
          let keHuName = ''
          // 同时获取下拉框的valu和lable值
          this.keHuOptions.forEach((item, index) => {
            if (this.addFrom.suoShuKeHu == item.itemNo) {
              keHuName = item.showName
            }
          })
          if (feeId == '' || feeId == undefined || feeId == null) {
            feeId = this.tabId
          }
          let name = '{"feeId":"' + feeId + '", "sysModel":"' + 5 + '","default_sdate":"' + this.addFrom.effectiveDate + '","default_edate":"' + this.addFrom.validDate + '","default_cno":"' + this.addFrom.contractNo + '","default_cname":"' + keHuName + '","default_code":"' + keHuCode1 + '","default_flg":"' + this.addFrom.biaoShi + '",'
          this.addFrom.addDataList.forEach((item, index) => {
            if (index != '0') {
              name += ','
            }
            var test1 = ''
            if (item.ext3 == null || item.ext3 == '' || item.ext3 == undefined) {
              // 错误处理
            } else {
              test1 = item.ext3
            }
            var test2 = ''
            // 等于2  下拉框
            if (item.attributeFlg == '2' || item.attributeFlg == '4') {
              test2 = item.attrStandard.substring(0, item.attrStandard.length - 8)
            } else {
              test2 = item.attrStandard.substring(0, item.attrStandard.length - 6)
            }
            // 等于4  复选框
            if (item.interControl == '4' && this.addFrom.modularIds != undefined) {
              let fuXuanKuangIdStr = this.addFrom.modularIds.toString()
              // console.log(fuXuanKuangStr, '99999')
              name += '"' + item.attrStandard + '":"' + fuXuanKuangIdStr + '"'
            } else {
              name += '"' + item.attrStandard + '":"' + test1 + '"'
            }
            if (item.ext2 != '' && item.ext2 != null && item.ext2 != undefined && (item.interControl == '2' || item.interControl == '4')) {
              name += ',"' + test2 + '":"' + item.ext2 + '"'
            }
            if (index == this.addFrom.addDataList.length - 1) {
              name += '}'
            }
          })
          saveCostDataAdd({
            params: name
          }).then(res => {
            this.$message.success('添加成功！')
            this.addLoading = false
            this.getListData()
            this.addDialog = false
          }).catch(err => {
            this.addLoading = false
            this.$message.error(err.message)
          })
          // console.log(name)
        } else {
          // console.log('error submit!!');
          return false
        }
      })
    },
    // 点击主表选中需要修改的行
    dianjixuanzhong (row, column, event) {
      this.xuanzhongArr = []
      this.xuanzhongArr = row
      this.currentXQ = 1
      // this.$nextTick(() => {
      //   this.$refs.tableRef[0].toggleRowSelection(row)
      // })
      this.getCostPageData(row)
      this.checkChange(this.checkDataArr)
      this.addFrom.suoShuKeHu = row.default_code // 所属客户
      this.addFrom.contractNo = row.default_cno // 合同编号
      this.addFrom.effectiveDate = row.default_sdate // 生效日期
      this.addFrom.validDate = row.default_edate // 有效日期
      // 适用标识
      this.addFrom.biaoShi = row.default_flg
      this.changeId = row.id
    },
    handleTabCurrentChange (val) {
      this.currentRow = val
    },
    // 点击修改按钮
    changeBtnClick () {
      // let selectData = this.$refs.tableRef[0].selection
      // console.log(selectData, '////')
      // console.log(selectData, '2222')
      if (this.xuanzhongArr.length == 0) {
        this.$message.error('请选择一条数据进行操作！')
      } else if (this.xuanzhongArr.length > 1) {
        this.$message.error('只能选择一条数据进行操作！')
      } else {
        this.xuanzhongArr = []
        // console.log(this.xuanzhongArr, '/////')
        this.addDialog = true
        this.title = '修改计费规则'
        this.addBtnShow = false
        this.addFrom.modularIds = []
        this.changeBtnShow = true
        // this.xuanzhongArr = []
        // this.getCostPageData(this.xuanzhongArr)
        // this.checkChange(this.checkDataArr)
        this.getQueryCusterData()
        // this.addFrom.suoShuKeHu = this.xuanzhongArr.default_code // 所属客户
        // this.addFrom.contractNo = this.xuanzhongArr.default_cno // 合同编号
        // this.addFrom.effectiveDate = this.xuanzhongArr.default_sdate // 生效日期
        // this.addFrom.validDate = this.xuanzhongArr.default_edate // 有效日期
        // this.changeId = this.xuanzhongArr.id
      }
    },
    // 修改确定
    changeSubmit (formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.changeLoading = true
          let feeId = this.feeId
          let fuXuanKuangIdStr = this.addFrom.modularIds
          let keHuCode = this.addFrom.suoShuKeHu
          let keHuName = ''
          // 同时获取下拉框的valu和lable值
          this.keHuOptions.forEach((item, index) => {
            if (this.addFrom.suoShuKeHu == item.itemNo) {
              // this.addFrom.suoShuKeHu = item.itemNo
              keHuName = item.showName
            }
          })
          console.log(keHuName, '444')
          if (feeId == '' || feeId == undefined || feeId == null) {
            feeId = this.tabId
          }
          let name = '{"feeId":"' + feeId + '", "sysModel":"' + 5 + '","default_sdate":"' + this.addFrom.effectiveDate + '","default_edate":"' + this.addFrom.validDate + '","default_cno":"' + this.addFrom.contractNo + '","id":"' + this.changeId + '","default_cname":"' + keHuName + '","default_code":"' + keHuCode + '","default_flg":"' + this.addFrom.biaoShi + '",'
          this.addFrom.addDataList.forEach((item, index) => {
            if (index != '0') {
              name += ','
            }
            var test1 = ''
            if (item.ext3 == null || item.ext3 == '' || item.ext3 == undefined) {
              // 错误处理
            } else {
              test1 = item.ext3
            }
            var test2 = ''
            if (item.attributeFlg == '2' || item.attributeFlg == '4') {
              test2 = item.attrStandard.substring(0, item.attrStandard.length - 8)
            } else {
              test2 = item.attrStandard.substring(0, item.attrStandard.length - 6)
            }
            // 等于4  复选框
            if (item.interControl == '4' && fuXuanKuangIdStr != undefined) {
              // console.log(fuXuanKuangIdStr.toString())
              name += '"' + item.attrStandard + '":"' + fuXuanKuangIdStr.toString() + '"'
            } else {
              name += '"' + item.attrStandard + '":"' + test1 + '"'
            }
            if (item.ext2 != '' && item.ext2 != null && item.ext2 != undefined && (item.interControl == '2' || item.interControl == '4')) {
              name += ',"' + test2 + '":"' + item.ext2 + '"'
            }
            if (index == this.addFrom.addDataList.length - 1) {
              name += '}'
            }
          })
          saveCostDataAdd({
            params: name
          }).then(res => {
            this.$message.success('修改成功！')
            this.changeLoading = false
            this.getListData()
            this.addDialog = false
          }).catch(err => {
            this.changeLoading = false
            this.$message.error(err.message)
          })
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
    // 新增取消
    addSpuClose (formName) {
      this.$refs[formName].resetFields()
      this.addFrom.contractNo = ''
      this.checkDataArr = []
      this.addFrom.suoShuKeHu = ''
      this.addFrom.suoShuKeHuName = ''
      this.addDialog = false
    },
    // 删除
    delBtnClick () {
      if (this.xuanzhongArr.length == 0) {
        this.$message.error('请选择一条数据进行操作！')
      } else if (this.xuanzhongArr.length > 1) {
        this.$message.error('只能选择一条数据进行操作！')
      } else {
        this.$confirm('是否确定删除？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        })
          .then(() => {
            deleteCostData({
              sysModel: '5',
              feeId: this.feeId || this.tabId,
              id: this.xuanzhongArr.id
            }).then(res => {
              this.$message.success('删除成功！')
              this.getListData()
            }).catch(err => {
              this.$message.error(err.message)
            })
          })
          .catch(() => {})
      }
    }
  }
}
</script>
<style scoped lang='less'>
/deep/ .el-tabs__item {
  width:150px;
  text-align: center;
  // background-color:#ccc ;
}
/deep/ .is-active{
  background-color:#0c46a2;
  color: #fff;
}

.inpBox{
  margin: 10px 0 0 -30px;
}

 /deep/ .inpBox .el-range-editor--mini .el-input__inner {
   width: 150px;
}
.searchBtnBox{
  margin-top: 10px;
}
.el-table__header tr,
  .el-table__header th {
    padding: 0;
    height: 40px;
}
.el-date-editor.el-input, .el-date-editor.el-input__inner {
    width:  280px;
    background-color:#fff;
}
.searchBtnBox{
  margin-top: 10px;
}
//  .demo-form-inline .el-form-item{
//   margin-bottom: 17px!important;
// }
</style>
